import { render, staticRenderFns } from "./PreviewLogoPortada.vue?vue&type=template&id=0d270d18"
import script from "./PreviewLogoPortada.vue?vue&type=script&lang=js"
export * from "./PreviewLogoPortada.vue?vue&type=script&lang=js"
import style0 from "./PreviewLogoPortada.vue?vue&type=style&index=0&id=0d270d18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports